import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataType } from '@shared/helpers/enums/data-type';
import { get } from 'lodash-es';
import moment from 'moment';

@Pipe({
  standalone: false,
  name: 'gridRowIterator',
})
export class GridRowIteratorPipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(
    value: Record<string, string | Date | number>,
    prop: string,
    dataType: DataType | undefined
  ): string {
    if (!value || !prop) return '';

    const result = get(value, prop, null);
    switch (dataType) {
      case DataType.Boolean:
        return this.translateService.instant(
          result ? 'admin.grid.yes' : 'admin.grid.no'
        );
      case DataType.Date:
        if (result === undefined || result === null) return '-';
        return moment(result).format('MM/DD/YYYY');
      default:
        return result?.toString() ?? '';
    }
  }
}
